import { render, staticRenderFns } from "./messageRecordList.vue?vue&type=template&id=979f2646&"
import script from "./messageRecordList.vue?vue&type=script&lang=js&"
export * from "./messageRecordList.vue?vue&type=script&lang=js&"
import style0 from "./messageRecordList.vue?vue&type=style&index=0&id=979f2646&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports